import config from 'netxcore@netx/core-asset/config';

Object.assign(config, {
	PAGE_SIZE: 30,
	CHUNK_SIZE: 30,
	DETAIL_TABS: ['preview', 'fileinfo', 'attributes', 'list'],
	DRAGGABLE: false,
	LIST_TYPE: ['card', 'curator', 'grid', 'list'],
	LIST_TYPE_DEFAULT: 'card',
	LIST_TYPES_ENABLED: false,
});

export default config;
